(function () {



  const config = {
    SAR: { step: 0.05, decimals: 2 },
    QAR: { step: 0.05, decimals: 2 },
    BHD: { step: 0.005, decimals: 3 },
    OMR: { step: 0.005, decimals: 3 },
    KWD: { step: 0.005, decimals: 3 }
  };

  function roundByCurrency(value, currency) {
    if (!config[currency] || isNaN(value)) return null;
    const { step, decimals } = config[currency];
    return (Math.round(value / step) * step).toFixed(decimals);
  }

  function extractNumber(text) {
    return parseFloat(text.replace(/[^\d.]/g, ''));
  }

  function applyBucksRounding() {
    document
      .querySelectorAll('.buckscc-converted[bucks-current][bucks-currency]')
      .forEach(el => {

        const currency = el.getAttribute('bucks-currency');
        const currentText = el.getAttribute('bucks-current'); // "KD 2.268"
        const currentValue = extractNumber(currentText);      // 2.268

        const rounded = roundByCurrency(currentValue, currency);
        if (!rounded) return;

        if (el.dataset.rounded === rounded) return;

        // ✅ update converted value ONLY
        el.setAttribute('bucks-current', `${currency} ${rounded}`);
        el.textContent = `${currency} ${rounded}`;
        el.dataset.rounded = rounded;
      });
  }

  // BUCKS loads async → retry
  [0, 300, 600, 1000, 2000].forEach(t =>
    setTimeout(applyBucksRounding, t)
  );

  const observer = new MutationObserver(applyBucksRounding);
  observer.observe(document.body, { childList: true, subtree: true });

})();
